module.exports = __webpack_public_path__ + "static/media/rawpixel-com.f309bdcf.jpg";